/**
 * Labels for ProfileAnswers pickers. Codes are stored; copy is UI-only.
 * Ancestry is a preference axis — never framed as a hard exclusion.
 */

export const ORIGIN_OPTIONS: { code: string; label: string }[] = [
  { code: "african", label: "African" },
  { code: "european", label: "European" },
  { code: "asian", label: "Asian" },
  { code: "latino", label: "Latino / Hispanic" },
  { code: "middle_eastern", label: "Middle Eastern" },
  { code: "indigenous", label: "Indigenous" },
  { code: "mixed", label: "Mixed" },
  { code: "other", label: "Other" },
  { code: "dutch", label: "Dutch" },
  { code: "german", label: "German" },
];

/** Accepted-partner list may include this opt-out of preference weighting. */
export const ORIGIN_ANY = { code: "any", label: "Open — no preference" } as const;

export const INTEREST_OPTIONS: { code: string; label: string }[] = [
  { code: "prayer", label: "Prayer" },
  { code: "worship", label: "Worship" },
  { code: "reading", label: "Reading" },
  { code: "hiking", label: "Hiking" },
  { code: "music", label: "Music" },
  { code: "cooking", label: "Cooking" },
  { code: "farming", label: "Farming / gardening" },
  { code: "sports", label: "Sports" },
  { code: "missions", label: "Missions" },
  { code: "family", label: "Family life" },
  { code: "crafts", label: "Crafts" },
  { code: "outdoors", label: "Outdoors" },
];
